"use client";

import * as React from "react";
import { motion } from "framer-motion";
const promotionalMessages = ["Kompleksowe strategie cyfrowe dla Twojego biznesu.", "Zwiększ widoczność online i przyciągnij lojalnych klientów.", "Mierzalne rezultaty, które budują zaufanie.", "Kreatywna estetyka i strategiczne podejście do marketingu."];
const marqueeMessages = [...promotionalMessages, ...promotionalMessages];
export default function PromotionalCarouselBanner() {
  return <section id="promotionalcarouselbanner" className="w-full bg-primary text-primary-foreground py-3 overflow-hidden shadow-md">
      <div className="w-full">
        <div className="relative flex overflow-x-hidden">
          <motion.div className="flex whitespace-nowrap" animate={{
          x: ["0%", "-50%"]
        }} transition={{
          duration: 40,
          ease: "linear",
          repeat: Infinity
        }}>
            {marqueeMessages.map((message, index) => <div key={index} data-index={index} className="flex items-center px-8 md:px-12">
                <p className="font-default font-medium text-sm md:text-base lg:text-lg tracking-wide">
                  {message}
                </p>
                {}
                <div className="ml-8 md:ml-12 w-1.5 h-1.5 rounded-lg bg-primary-foreground/30" />
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}